import { FieldSwitch, FlexBox, Table } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Tag } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { PureComponent } from 'react';


import styles from '../tags.module.scss';

type TemplatesTableRowOwnProps = {
  tag: Tag;
  toggleActivation: (tag: Tag) => void;
};

type StateProps = {};

type Props = TemplatesTableRowOwnProps & StateProps;

export class TagsTableRow extends PureComponent<Props> {
  @boundMethod
  handleToggleButtonChange(): void {
    const { tag, toggleActivation } = this.props;
    if (tag.is_deactivated) {
      ampli.settingsTagsTagActivated({ tagName: tag.name });
    } else {
      ampli.settingsTagsTagDeactivated({ tagName: tag.name });
    }

    toggleActivation(tag);
  }

  render() {
    const { tag } = this.props;

    return (
      <Table.Tr>
        <Table.Td>
          <FlexBox alignItems="center">
            <div
              className={styles.tagIndicator}
              style={{ background: tag.color ?? 'transparent' }}
            />
            <span className={styles.tagName}>{tag.name}</span>
          </FlexBox>
        </Table.Td>
        <Table.Td>
          {tag.usage_count ? `${tag.usage_count} times` : 'unused'}
        </Table.Td>
        <Table.Td>
          <FieldSwitch
            input={{
              name: 'active',
              value: 'active',
              checked: !tag.is_deactivated,
              onChange: () => this.handleToggleButtonChange(),
            }}
          />
        </Table.Td>
      </Table.Tr>
    );
  }
}
